import { createContext, useEffect, useReducer } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
// import { errorLog } from '@commonservices';

const local_isAuthenticated = localStorage.getItem('isAuthenticated') ? localStorage.getItem('isAuthenticated') == 'true' && true : false;

const initialState = {
    user: null,
    isInitialized: false,
    isAuthenticated: local_isAuthenticated ? local_isAuthenticated : false,
};

const reducer = (state, action) => {
    switch (action.type) {
    case 'INIT': {
        const { isAuthenticated, user } = action.payload;
        return { ...state, isAuthenticated, isInitialized: true, user };
    }

    case 'LOGIN': {
        return { ...state, isAuthenticated: true };
    }

    case 'LOGOUT': {
        return { ...state, isAuthenticated: false, user: null };
    }

    case 'REGISTER': {
        const { user } = action.payload;

        return { ...state, isAuthenticated: true, user };
    }

    default:
        return state;
    }
};

const AuthContext = createContext({
    ...initialState,
    method: 'JWT',
    login: () => { },
    logout: () => { },
    register: () => { },
});

export const AuthProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState);
    const navigate = useNavigate();

    // const login = async (email, password) => {
    const login = async () => {
    // const response = await axios.post("/api/auth/login", { email, password });
    // const { user } = response.data;

        dispatch({ type: 'LOGIN' });
    };

    const register = async (email, username, password) => {
        const response = await axios.post('/api/auth/register', { email, username, password });
        const { user } = response.data;

        dispatch({ type: 'REGISTER', payload: { user } });
    };

    const logout = async () => {
    // await errorLog({ message: 'JwtAuthContext' }, "JwtAuthContext", "logout");
        localStorage.removeItem('userDetails');
        localStorage.setItem('isAuthenticated', false);
        const userId = {
            'user_id': 0,
            'user_name': 'expired',
        };
        const data = Object.assign({}, userId);
        localStorage.setItem('userDetails', JSON.stringify(data));
        localStorage.setItem('isAuthenticated', false);
        navigate('/session/signin');
    };

    useEffect(() => {
    }, []);

    // SHOW LOADER
    // if (!state.isInitialized) return <MatxLoading />;

    return (
        <AuthContext.Provider value={{ ...state, method: 'JWT', login, logout, register }}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthContext;
